class ScrollingAnimationBlock
{
	constructor(el: Element)
	{
		let itemBlocks = el.querySelectorAll(".scrolling-animation-item-block");

		itemBlocks.forEach((item, index) =>
		{
			//Wire up nav buttons
			if (index != 0)
			{
				let prevButton = item.querySelector(".splide__arrows:has(.splide__arrow--prev)");

				if (prevButton)
				{
					prevButton.classList.remove("hidden");

					prevButton.addEventListener("click", () =>
					{
						let stickyRect = item.getBoundingClientRect();
						let offset = window.innerHeight - stickyRect.top;

						if (stickyRect.top == 0 && item.nextElementSibling)
						{
							offset = (window.innerHeight - item.nextElementSibling.getBoundingClientRect().top) + window.innerHeight;
						}

						window.scrollBy({ top: -offset, behavior: 'smooth' });
					});
				}
			}

			if (index != itemBlocks.length - 1)
			{
				let nextButton = item.querySelector(".splide__arrows:has(.splide__arrow--next)");


				if (nextButton)
				{
					nextButton.classList.remove("hidden");
					nextButton.addEventListener("click", () =>
					{
						item.nextElementSibling?.scrollIntoView();
					});

				}
			}

			//Wire up pagination buttons
			let paginationContainer = item.querySelector(".scrolling-animation-item-block__picture-nav__nav");

			if (paginationContainer)
			{
				let paginationItem = document.createElement('div');
				paginationItem.classList.add("scrolling-animation-item-block__picture-nav__nav__item")

				for (var i = 0; i < itemBlocks.length; i++)
				{
					let clone = <HTMLDivElement>paginationItem.cloneNode();
					clone.setAttribute("data-index", i.toString());

					if (i == index)
					{
						clone.classList.add("active");
					}

					paginationContainer.insertAdjacentElement("beforeend", clone);
				}

				let paginationButtons = paginationContainer.querySelectorAll(".scrolling-animation-item-block__picture-nav__nav__item");
				paginationButtons.forEach((button, index) =>
				{
					button.addEventListener("click", () =>
					{
						let blockBoundindRect = el.getBoundingClientRect();
						let index = button.getAttribute("data-index");

						//debugger;
						if (index && paginationButtons[paginationButtons.length - 1] == button)
						{
							itemBlocks[Number.parseInt(index)]?.scrollIntoView();
						} else if (index)
						{
							let offset = Number.parseInt(index) * window.innerHeight;
							window.scrollBy({ top: blockBoundindRect.top + offset, behavior: 'smooth' });
						}
					});
				});
			}


			//Check if content exceeds screen height
			this.toggleAnimation(item);

			window.addEventListener("resize", () =>
			{
				this.toggleAnimation(item);
			});
		});
	}

	toggleAnimation(item: Element)
	{
		let contentBlock = item.querySelector(".scrolling-animation-item-block__content");
		if (contentBlock)
		{
			let contentRectHeight = contentBlock.getBoundingClientRect().height;

			if (window.innerWidth <= 768)
			{
				let picture = item.querySelector(".scrolling-animation-item-block__picture-nav");
				contentRectHeight += picture ? picture.getBoundingClientRect().height + 120 : 0;
			}

			if (contentRectHeight > window.innerHeight)
			{
				item.classList.add("scrolling-animation-item-block--relative");
			} else
			{
				item.classList.remove("scrolling-animation-item-block--relative");
			}
		}
	}
}

document.addEventListener('DOMContentLoaded', () =>
{
	const htmlEl = document.documentElement;

	if (htmlEl.classList.contains('epi-editmode') ||
		htmlEl.classList.contains('epi-previewmode') ||
		window.self !== window.top)
	{
		htmlEl.classList.add('scrolling-animation-in-iframe');
		return;
	}

	document.querySelectorAll(".scrolling-animation-block").forEach(el =>
	{
		new ScrollingAnimationBlock(el);
	});
});
